<template>
  <div class="navbar">
    <ul class="navbar-center">
      <div
        class="nav-level-1"
        :class="{ hasChildren: item.children && item.children.length }"
        v-for="item in list"
        :key="item.id"
      >
        <div @click="handleFirst(item)">{{ item.name }}</div>
        <ul class="nav-level-2" :class="{ hasMargin: calcMargin(item.name, item.children) }">
          <li v-for="item2 in item.children" :key="item2.id" @click="handleSecond(item2, item)">
            {{ item2.name }}
          </li>
        </ul>
      </div>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    /**
     * 获取目录列表
     * 该方法用于获取目录列表，并过滤掉状态为 false 的子目录
     */
    async getList() {
      const { data } = await this.$fetch.get("/api/directory/navList");
      const arr = [];
      data.forEach(element => {
        let obj = element

        obj.children = obj.children.filter(item2 => {
            return item2.status
        })
        arr.push(element)
      });
      this.list = arr;
    },

    handleFirst(item) {
      if (!item.children || item.children.length === 0) {
        const query = {
          name: item.name,
          id: item.id,
        };
        this.toListRouter(query);
      }
    },

    // 跳转二级页面
    handleSecond(item2) {
      if(item2.name === '讲师介绍' || item2.name === '学习文档' ||item2.name === '学习视频' ||item2.name === '考核结果'){
        const queryMap = {
          '讲师介绍':'/topic/topic-teacher',
          '学习文档':'/topic/topic-material',
          '学习视频':'/topic/topic-lesson',
          '考核结果':'/topic/topic-certificate'
        }

        window.location.href = queryMap[item2.name]
        // this.$router.push({
        //   path: queryMap[item2.name],
        // });
      } else {
        const query = {
          // name: item2.name,
          id: btoa(item2.id), // 编码为 Base64 编码的 ASCII 字符串
        };
        this.toListRouter(query);
      }
    },

    toListRouter(query) {
      this.$router.push({
        path: `/article-list`,
        query,
      });
    },
    /**
     * 计算边距
     * 该方法用于计算父元素和子元素之间的边距
     * @param {Array} parent - 父元素数组
     * @param {Array} children - 子元素数组
     * @returns {boolean} - 如果子元素中有名称长度乘以 16 大于父元素宽度的，则返回 true，否则返回 false
     */
    calcMargin(parent, children) {
      const parentWidth = parent.length * 24;
      const hasChildren = children.find((item) => {
        return item.name.length * 16 > parentWidth;
      });

      return hasChildren;
    },
  },
};
</script>

<style lang="less" scoped>
ul,
li {
  list-style: none;
}

.navbar {
  width: 100%;
  height: 60px;
  background: #3560ab;
  min-width: 1200px;
}

.navbar-center {
  height: 100%;
  font-size: 24px;
  color: #ffffff;
  font-weight: bold;
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.nav-level-1 {
  position: relative;
  height: 100%;
  line-height: 60px;
  padding: 0 20px;

  &:hover {
    .nav-level-2 {
      display: flex;
    }

    &.hasChildren::before {
      display: flex;
    }
  }

  // &::before {
  //   position: absolute;
  //   left: 50%;
  //   transform: translateX(-50%);
  //   z-index: 120;
  //   bottom: -20px;
  //   display: none;
  //   border-top: 10px solid #3560ab;
  //   border-bottom: 10px solid transparent;
  //   border-right: 10px solid transparent;
  //   border-left: 10px solid transparent;
  //   content: "";
  // }
}

.nav-level-2 {
  position: absolute;
  padding: 0;
  min-width: 100%;
  width: max-content;
  top: 60px;
  left: 0;
  display: none;
  color: #383838;
  font-size: 18px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(255, 255, 255, 0.9);
  z-index: 100;
  flex-direction: column;
  align-items: center;
  background: rgba(53, 96, 171, 0.8);

  &.hasMargin {
    margin-left: -50%;
  }

  li {
    color: white;
    text-decoration: none;
    color: #fff;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding: 0 20px;
  }

  li:hover {
    color: #fff;
  }
}
</style>
